import { useNavigate } from "react-router-dom";
import { LogOut, LayoutDashboard } from 'lucide-react';
import { useAuth } from "./AuthContext";
import AuthEntryButtons from "./AuthEntryButtons";
import { isAppHost, shouldEnforceDomainSplit } from "../constants/siteDomains";
import { toAppUrl } from "../constants/siteDomains";
import { MARKETING_HOME_URL } from "../constants/externalLinks";

const AuthNavButton = ({ isMobile = false }) => {
    const { isAuthenticated, logout } = useAuth();
    const navigate = useNavigate();
    const painelUrl = toAppUrl('/painel');

    const handleLogout = async () => {
        await logout();
        if (shouldEnforceDomainSplit() && !isAppHost()) {
            window.location.assign(MARKETING_HOME_URL);
            return;
        }
        navigate('/login');
    };

    if (isAuthenticated && isAppHost()) {
        return (
            <div className="flex items-center gap-4">
                <a
                    href={painelUrl}
                    className={`flex items-center gap-2 font-medium transition-colors ${isMobile
                            ? 'bg-[#A56096] text-white px-4 py-2 rounded-full text-sm'
                            : 'text-[#3A5859] hover:text-[#A56096]'
                        }`}
                >
                    <LayoutDashboard className="h-4 w-4" />
                    Painel
                </a>

                <button
                    onClick={handleLogout}
                    title="Sair"
                    className={`flex items-center justify-center p-2 rounded-full transition-colors ${isMobile
                            ? 'bg-red-500 text-white hover:bg-red-600'
                            : 'bg-red-100 text-red-600 hover:bg-red-200'
                        }`}
                >
                    <LogOut className="h-5 w-5" />
                </button>
            </div>
        );
    }

    return <AuthEntryButtons variant="header" />;
};

export default AuthNavButton;
